import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

//  Actions - imported
import { editGroupName, editGroupDescription, editGroupPrivacy, getGroupById } from '../../actions/groupActions';
import { setPage, add_To_Recent_History, toggleCreateGroupModal } from '../../actions/navActions';

// wrapper layout
import Layout from '../../components/layout/Layout';

// Components
import CreateGroupSlidingForm from '../../components/GroupPage/CreateGroup/CreateGroupModal/CreateGroupSlidingForm';

const CreateGroup = ({ 
    setPage,
    add_To_Recent_History,
    nav: { 
        createGroupModal,
    }, 
    toggleCreateGroupModal,
    history
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width state
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    let previousUrl = url.searchParams.get("goBack");
    const hostname = window.location.hostname;

    // Set page on component mount
    useEffect(() => {
        setPage('create group');
        add_To_Recent_History(url.pathname);  // current url

        // Close post modal if open
        if(createGroupModal) {
            toggleCreateGroupModal();
        }

        // Event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up event listener
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Function to handle window size change
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        mixpanel.track("Create Group Page View");
    }

    // Trigger Mixpanel analytics on initial render
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    // Check if the window size is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Redirect logic for non-mobile devices
    if(!isMobile) {
        if(previousUrl !== null) {
            toggleCreateGroupModal();

            history.push(`/${previousUrl}`)
        }
    }

    return (
        <Fragment>

            {/* Layout component with profile edit mode */}
            <Layout page={'create group'}>
                <div style={{height: '75%', padding: '5px', boxSizing: 'border-box', overflowY: 'scroll'}}>
                    <CreateGroupSlidingForm is_create_page />   
                </div>
                {/* <CreateGroupForm toggleNameModal={toggleNameModal} toggleDescriptionModal={toggleDescriptionModal} togglePrivacyModal={togglePrivacyModal} /> */}
                
            </Layout>

        </Fragment>
    )
}

CreateGroup.propTypes = {
    setPage: PropTypes.func.isRequired, 
    add_To_Recent_History: PropTypes.func.isRequired,
    editGroupName: PropTypes.func.isRequired,
    editGroupDescription: PropTypes.func.isRequired,
    editGroupPrivacy: PropTypes.func.isRequired,
    getGroupById: PropTypes.func.isRequired,
    toggleCreateGroupModal: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired, 
    group: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
    group: state.group,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setPage,
    add_To_Recent_History,
    editGroupName, 
    editGroupDescription,
    editGroupPrivacy,
    getGroupById,
    toggleCreateGroupModal
})(CreateGroup);
